<template>
    <div class="videos">
        <h2>Видео</h2>
        <btn l='Синхранизировать с YouTube' i='exchange' @press="sync()" size="medium" />
        <btn l='Добавить видео' i='plus' @press="create()" size="medium" />
        <hr/>
        <i-list :fields="fields" :data="videos" @input="edit" />
        <modal title="Видео +" name="video-edit" :height="440" :noFooter="false">
            <div style="padding:6px">
                <i-form :data="currentSlide" :scheme="formScheme" @input="(data)=>{setSlides(data)}" :showSaveButton="false" />
            </div>
            <div slot="footer">
                <btn l="Удалить" t='d' s='m' i='trash' @press="remove" pull='left'></btn>
                <btn l="Сохранить" t='s' s='m' i='save' @press="saveForm" pull='right'></btn>
                <btn l="Отмена" t='df' s='m' i='times' @press="cancel" pull='right'></btn>
            </div>
        </modal>
    </div>
</template>
<script>
export default {
    name: 'videos',
    methods: {
        cancel() { this.$store.commit('modalClose', 'video-edit'); },
        saveForm() { _i.bus.$emit('save-form'); },
        remove() {
            this.$store.dispatch("videosRemoveCRUD", this.currentSlide._id);
            this.$store.commit('modalClose', "video-edit");
        },
        edit(tr) {
            this.currentSlide = tr;
            console.log(this.currentSlide);
            this.$store.commit('modalOpen', "video-edit");
        },
        create() {
            this.currentSlide = {};
            this.$store.commit('modalOpen', "video-edit");
        },
        sync() {
            this.$http.post('apis/youtube', { command: 'sync', context: "UUU9qj3LruqFcDAufKrV2YAg" });
        },
        setSlides(video) {
            this.$store.dispatch("videosSaveCRUD", video);
            this.$store.commit('modalClose', "video-edit");
            //console.log("videos:",);

        }
    },
    created() {
        _i.crudApi.makeStore(this, 'videos', 'content/videos')
    },
    computed: {
        videos() {
            return this.$store.state.videos.list;
        }
    },
    data() {
        return {
            currentSlide: {},
            formScheme: {
                "title": {
                    type: "string",
                    label: "Название",
                    required: true
                },
                "description": {
                    type: "string",
                    label: "Описание",
                    required: true
                },
                "src": {
                    type: "string",
                    label: "Адрес видео",
                    required: true
                },
                "host": {
                    type: "options",
                    options: [{ label: 'YouTube', value: 'youtube' }, { label: 'Vimeo', value: 'vimeo' }],
                    label: "Источник",
                    required: true
                },
                "date": {
                    type: "date",
                    label: "Дата",
                    required: true
                },
                "lang":{
                  type:"options",
                  label:"Язык",
                  required:true,
                  options:[{value:"kz", label:"kz"},{value:"ru", label:"ru"},{value:"en", label:"en"}]
                }
            },
            fields: [
                { label: '№', type: 'index' },
                { label: 'Название', name: 'title' },
                //{label:'Описание',name:'description'},
                { label: 'Дата', name: 'date', type: 'date' }
            ]
        }
    }
}
</script>
<style lang="css" scoped>
.videos {
    padding: 6px 12px;
}
</style>